module.exports = __webpack_public_path__ + "img/18.e93fb1db.png";